import axios from "axios";
import { baseUrl } from "./baseUrl";
import TokenService from "./token.service";

const CartService = () => {
  const { getToken, rememberGet } = TokenService();
  const token = getToken(rememberGet());

  const addCart = (data) => {
    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseUrl}/cart/`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };

    return axios.request(config);
  };

  const getCart = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseUrl}/cart/`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios.request(config);
  };

  const decreaseItem = (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseUrl}/cart/decrease/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios.request(config);
  };

  const increaseItem = (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseUrl}/cart/increase/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios.request(config);
  };

  const removeItem = (id) => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${baseUrl}/cart/delete/${id}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return axios.request(config);
  };

  return { removeItem, increaseItem, decreaseItem, getCart, addCart };
};

export default CartService;
